export default function global_variables() {
    return {
        retrieve_trip: '/rydsom/trip/retrieve',
    }
}
